module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"projects":"Projects","contact":"Contact","experience":"Experience"},"fi":{"projects":"Projektit","contact":"Yhteystiedot","experience":"Kokemus"}}')
  delete Component.options._Ctor
}
